import request from '@/utils/request'

export function getDetail() {
  return request({
    url: '/api/an/AnExpo/getExpoContactsListAll',
    method: 'get',
    params: {}
  })
}

export function saveDetail(data) {
  return request({
    url: '/api/an/AnExpo/addOrUpdateExpoContacts',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/record.js